<template>
  <div>
    <el-dialog
      width="60%"
      title="吴忠仪表销售总公司费用申请单"
      :visible.sync="addFysqdView"
      :before-close="colseFysqd">
      <el-row style="text-align: center;margin-bottom: 20px">
        <span style="font-size: 20px">吴忠仪表销售总公司费用申请单</span>
      </el-row>
      <el-row style="text-align: left;margin-left: 20px">
        <el-col :span="7">申请部门：{{ addFysqdData.bmmc }}</el-col>
        <el-col :span="7">日期：{{ addFysqdData.rq }}</el-col>
        <el-col :span="7">单据号：{{ addFysqdData.djh }}</el-col>
        <el-col :span="3">单位： 元</el-col>
      </el-row>
      <el-row>
        <div style="display:inline-flex;width: 95%">
          <table ref="myTable" class="tableStyle" border>
            <tr>
              <td class="td1">申请人</td>
              <td class="td2">
                {{ addFysqdData.jkr }}
                <el-input v-model="addFysqdData.jkrid" style="width: 50%;display: none"></el-input>
              </td>
              <td class="td3"></td>
              <td class="td4"></td>
            </tr>
            <tr>
              <td class="td1">出差事由</td>
              <td class="td2">{{ addFysqdData.fysy }}</td>
              <td class="td3"></td>
              <td class="td4"></td>
            </tr>
            <tr v-if="[1, 2].indexOf(addFysqdData.fysys) !== -1">
              <td class="td1">费用项目</td>
              <td class="td2">{{ addFysqdData.xiangmu }}</td>
              <td class="td3"></td>
              <td class="td4"></td>
            </tr>
            <tr v-else>
              <td class="td1">费用描述</td>
              <td class="td2">{{ addFysqdData.fyms }}</td>
              <td class="td3"></td>
              <td class="td4"></td>
            </tr>
            <tr>
              <td class="td1">预计金额</td>
              <td class="td2">{{ addFysqdData.je }}</td>
              <td class="td3">销售公司经理</td>
              <td class="td4" style="text-align: center">{{ addFysqdData.shr }}</td>
            </tr>
            <tr>
              <td class="td1">金额大写</td>
              <td class="td2">{{ addFysqdData.dxje }}</td>
              <td class="td3">经办人</td>
              <td class="td4" style="text-align: center">{{ addFysqdData.operator }}</td>
            </tr>
          </table>
        </div>
        <div style="width: 20px;display: inline-flex;margin-left: 5px">
          <span>第<br>一<br>联<br>财务记<br>账<br>联</span>
        </div>
      </el-row>

      <el-row style="width: 95%">
        <el-divider content-position="left" style="width: 90%">审核情况</el-divider>
        <el-table
          class="tableClass"
          :data="shData"
          size="small"
          border
          :header-cell-style=" {background:'#F8FCFF',color:'#606266'}">
          <el-table-column label="序号" align="center" type="index" width="50" />
          <el-table-column label="日期" header-align="center" align="left" prop="shsj" />
          <el-table-column label="审核人" header-align="center" align="left" prop="shr" width="100px" />
          <el-table-column label="审核金额" header-align="center" align="right" prop="shje" />
          <el-table-column label="审核结果" header-align="center" align="left" prop="shbz">
            <template slot-scope="scope">
              <span>{{ scope.row.shbz === '1' ? '审核通过' : '审核不通过' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="审核意见" header-align="center" align="left" prop="shyj" />
        </el-table>
      </el-row>

      <el-row style="margin-top: 20px;text-align: center">
        <span class="dialog-footer">
          <el-button size="small" @click="colseFysqd()">关 闭</el-button>
        </span>
      </el-row>
    </el-dialog>

  </div>
</template>

<script>
export default {
  name: 'addFysq',
  props: {
    // eslint-disable-next-line vue/require-default-prop
    addFysqdData: Object,
    // eslint-disable-next-line vue/require-default-prop
    showBol: Array,
    // eslint-disable-next-line vue/require-default-prop
    view: String,
    // eslint-disable-next-line vue/require-default-prop
    shData: Array
  },
  data() {
    return {
      addFysqdView: false,
      jkrQueryView: false,
      xaingmuQueryView: false,
      queryParams: {
        currentPage: 1,
        pageSize: 100,
        billNumber: undefined,
        startTime: undefined,
        endTime: undefined
      },
      queryJkr: {
        jkr: ''
      },
      jkrDate: []
    }
  },
  created() {
    if (this.showBol[0]) {
      this.addFysqdView = true
    }
  },
  methods: {
    jkrQuery() {
      this.jkrQueryView = true
      this.getJkrList()
    },
    colseFysqd() {
      this.addFysqdView = false
      this.$emit('colseFysqd')
    },
    getJkrList() {
      this.$post('/crm/businessTripApplysNew/juNames').then(res => {
        this.jkrDate = res.data
      })
    },
    xaingmuQuery() {
      this.xaingmuQueryView = true
      this.getXiangmuList()
    },
    //保存费用申请单
    addFysqdForm() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(51,48,48,0.7)'
      })
      this.$post('/crm/expenseApplicationsNew/expenseApplicationSaveNew', this.addFysqdData).then(res => {
        if (res.success) {
          this.$message.success('费用申请单保存成功!')
          this.colseFysqd()
          this.$emit('getList')
        } else {
          this.$message.error('费用申请单保存失败!')
        }
        loading.close()
      })
    },
    handleJkrQuery() {
      var data = {
        cname: this.queryJkr.jkr
      }
      this.$post('/crm/businessTripApplysNew/getCpersonNames', data).then(res => {
        this.jkrDate = res.data
      })
    },
    handleJkrChange(row) {
      this.addFysqdData.jkr = row.cname
      this.addFysqdData.jkrid = row.code
      this.jkrQueryView = false
    },
    Nindex(index) {
      const page = this.queryParams.currentPage
      const pageSize = this.queryParams.pageSize
      return index + 1 + (page - 1) * pageSize
    },
    //监听金额数据，更改金额大写
    handleInputChange(money) {
      var ss = money.toString().replace(/[^\d.]/g, '')
      var reg = /^[0-9]+\.?[0-9]*?$/
      if (!reg.test(ss)) {
        this.addFysqdData.je = ''
        money = ''
      }
      let i
      var cnNums = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'] //汉字的数字
      var cnIntRadice = ['', '拾', '佰', '仟'] //基本单位
      var cnIntUnits = ['', '万', '亿', '兆'] //对应整数部分扩展单位
      var cnDecUnits = ['角', '分', '毫', '厘'] //对应小数部分单位
      var cnInteger = '整' //整数金额时后面跟的字符
      var cnIntLast = '元' //整型完以后的单位
      var maxNum = 999999999999999.9999 //最大处理的数字
      var IntegerNum //金额整数部分
      var DecimalNum //金额小数部分
      var ChineseStr = '' //输出的中文金额字符串
      var parts //分离金额后用的数组，预定义
      var Symbol = ''//正负值标记
      if (money === '') {
        this.addFysqdData.dxje = ''
        return ''
      }
      money = parseFloat(money)
      if (money >= maxNum) {
        alert('超出最大处理数字')
        return ''
      }
      if (money === 0) {
        ChineseStr = cnNums[0] + cnIntLast + cnInteger
        return ChineseStr
      }
      if (money < 0) {
        money = -money
        Symbol = '负 '
      }
      money = money.toString() //转换为字符串
      if (money.indexOf('.') === -1) {
        IntegerNum = money
        DecimalNum = ''
      } else {
        parts = money.split('.')
        IntegerNum = parts[0]
        DecimalNum = parts[1].substr(0, 4)
      }
      if (parseInt(IntegerNum, 10) > 0) { //获取整型部分转换
        var zeroCount = 0
        var IntLen = IntegerNum.length
        for (i = 0; i < IntLen; i++) {
          var n = IntegerNum.substr(i, 1)
          var p = IntLen - i - 1
          var q = p / 4
          var m = p % 4
          if (n === '0') {
            zeroCount++
          } else {
            if (zeroCount > 0) {
              ChineseStr += cnNums[0]
            }
            zeroCount = 0 //归零
            ChineseStr += cnNums[parseInt(n)] + cnIntRadice[m]
          }
          if (m === 0 && zeroCount < 4) {
            ChineseStr += cnIntUnits[q]
          }
        }
        ChineseStr += cnIntLast
        //整型部分处理完毕
      }
      if (DecimalNum !== '') { //小数部分
        var decLen = DecimalNum.length
        for (i = 0; i < decLen; i++) {
          var as = DecimalNum.substr(i, 1)
          if (as !== '0') {
            ChineseStr += cnNums[Number(as)] + cnDecUnits[i]
          }
        }
      }
      if (ChineseStr === '') {
        ChineseStr += cnNums[0] + cnIntLast + cnInteger
      } else if (DecimalNum === '') {
        ChineseStr += cnInteger
      }
      this.addFysqdData.dxje = Symbol + ChineseStr
    }
  }
}
</script>

<style scoped lang="scss">
.tableStyle {
  text-align: left;
  width: 100%;
  margin-top: 10px;
  tr {
    height: 40px;
  }
}
.td1 {
  width: 9%;
  text-align: center;
}
.td2 {
  width: 50%;
}
.td3 {
  width: 9%;
  text-align: center;
}
.td4 {
  width: 9%;
}
.el-radio {
  margin-right: 10px !important;
}
::v-deep .el-radio__label {
  padding-left: 3px !important;
}
::v-deep .borderHide .el-input__inner {
  height: 30px;
  border-radius: 0;
  border-top: none;
  border-left: none;
  border-right: none;
}
</style>
